export default __webpack_public_path__ + "static/media/settings-icon.2224e1c4.png";